"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'app';
exports.RESET_STORE = exports.namespace + "/RESET_STORE";
exports.REHYDRATE_STORE = exports.namespace + "/REHYDRATE_STORE";
exports.SET_NAVIGATION_READY = exports.namespace + "/SET_NAVIGATION_READY";
exports.SET_EPG_DAY_LOADED = exports.namespace + "/SET_EPG_DAY_LOADED";
exports.REMOVE_EPG_DAY_LOADED = exports.namespace + "/REMOVE_EPG_DAY_LOADED";
//# sourceMappingURL=constants.js.map